import React from 'react';
import "./Line.css"
import { useHistory } from "react-router-dom"
const Line = (props) => {
    const history = useHistory()
    return (
        <div className="row">
                <span>{props.title}</span>
            {
                props.link &&
                <span className={"more-detail"} onClick={() => history.push(`${props.link}`)}>{"مشاهده بیشتر"}</span>
            }
        </div>
    );
};

export default Line;
